<template>
  <AdblockTopbar />
  <div class="px-4 max-w-screen-xl lg:mx-auto">
    <HeaderApp />
    <div class="text__view flex flex-col justify-center text-center mb-5">
      <h1 class="font-semibold text-2xl my-5">Visual Hooks</h1>
      <p class="leading-6 max-w-5xl mx-auto">
        Discover how to create stop-scrolling ads with these great examples of
        their first 3-seconds
      </p>
    </div>
    <div class="relative py-10 sm:py-0">
      <button
        @click="backToInitial()"
        class="cursor-pointer z-10 absolute top-0 mt-0 sm:mt-3 left-0 flex justify-center w-8 h-8 rounded-full bg-gray-200 p-1 focus:outline-none duration-300 hover:bg-gray-300"
      >
        <svg
          class="h-5 w-5"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="rgb(79 70 229)"
          aria-hidden="true"
        >
          <path
            fill-rule="evenodd"
            d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
            clip-rule="evenodd"
          />
        </svg>
      </button>

      <div class="flex items-center p-10 relative">
        <div
          class="wrapper__info-ad p-6 h-2/5 max-h-80"
          :class="{ lock: lock }"
        >
          <div class="info-ad__image h-full relative z-30">
            <p
              class="absolute z-50 text__center mt-3 text-sm bg-gray-500 w-16 justify-center flex p-1 rounded-lg text-white"
            >
              {{ index_video + 1 }} of {{ selectedHook.video_link.length }}
            </p>
            <button
              @click="selectNextVideo()"
              class="absolute m-1 z-50 right-0 button__change flex justify-center w-8 h-8 rounded-full bg-gray-200 p-1 focus:outline-none duration-300 hover:bg-indigo-200"
            >
              <svg
                class="h-5 w-5"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="rgb(79 70 229)"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
            </button>
            <VideoTemplate
              :key="selectedHook.video_link[index_video]"
              :src="selectedHook.video_link[index_video]"
            />
            <button
              @click="selectPrevVideo()"
              class="absolute m-1 z-50 left-0 button__change flex justify-center w-8 h-8 rounded-full bg-gray-200 p-1 focus:outline-none duration-300 hover:bg-indigo-200"
            >
              <svg
                class="h-5 w-5"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="rgb(79 70 229)"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
            </button>
          </div>
          <div class="info-ad__text px-10 pt-20 pb-10">
            <div class="py-5">
              <h1 class="font-semibold">{{ selectedHook.video_name }}</h1>
            </div>
            <div>
              <p class="text-sm leading-6">{{ selectedHook.analysis }}</p>
            </div>
            <div class="flex mt-20 gap-3">
              <button
                @click="selectPreviousAdTest()"
                class="flex justify-center w-8 h-8 rounded-full bg-gray-200 p-1 focus:outline-none duration-300 hover:bg-gray-300"
              >
                <svg
                  class="h-5 w-5"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="rgb(79 70 229)"
                  aria-hidden="true"
                >
                  <path
                    fill-rule="evenodd"
                    d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                    clip-rule="evenodd"
                  />
                </svg>
              </button>
              <button
                @click="selectNextAdTest()"
                class="flex justify-center w-8 h-8 rounded-full bg-gray-200 p-1 focus:outline-none duration-300 hover:bg-gray-300"
              >
                <svg
                  class="h-5 w-5"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="rgb(79 70 229)"
                  aria-hidden="true"
                >
                  <path
                    fill-rule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clip-rule="evenodd"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref, onBeforeMount } from "vue";
import { useStore } from "vuex";
import AdblockTopbar from "@/components/AdblockTopbar";
import HeaderApp from "@/components/Header";
import VideoTemplate from "../../../src/components/VideoTemplate.vue";
import { useRouter } from "vue-router";

export default {
  components: { HeaderApp, VideoTemplate, AdblockTopbar },
  props: {
    lock: Boolean,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    onBeforeMount(async () => {
      const status = computed(() => store.state.status);
      if (!status.value) {
            console.log("1")

        router.push("/pricing");
      }
    });

    let index_video = ref(0);
    const selectedHook = computed(() => store.state.selectedHook);
    const hooks_length = computed(() => store.state.hooks.length);
    const backToInitial = () => {
      router.push("/hooks");
    };
    const selectNextVideo = () => {
      if (index_video.value + 1 < selectedHook.value.video_link.length) {
        index_video.value++;
      }
    };
    const selectPrevVideo = () => {
      if (index_video.value - 1 >= 0) {
        index_video.value--;
      }
    };
    const selectNextAdTest = () => {
      if (selectedHook.value.index + 1 < hooks_length.value) {
        index_video.value = 0;
        store.commit("SET_HOOKS", selectedHook.value.index + 1);
      }
    };
    const selectPreviousAdTest = () => {
      if (selectedHook.value.index - 1 >= 0) {
        index_video.value = 0;
        store.commit("SET_HOOKS", selectedHook.value.index - 1);
      }
    };
    return {
      selectedHook,
      backToInitial,
      selectNextAdTest,
      selectPreviousAdTest,
      index_video,
      selectNextVideo,
      selectPrevVideo,
    };
  },
};
</script>

<style>
.lock {
  filter: blur(18px);
  pointer-events: none;
}

.wrapper__info-ad {
  @apply grid-cols-1;
  display: grid;
  gap: 20px;
}
@screen sm {
  .wrapper__info-ad {
    grid-template-columns: 0.5fr 1fr;
  }
}
.info-ad__text {
  background-image: linear-gradient(
    to right,
    rgba(252, 252, 252, 0.87),
    rgba(102, 126, 234, 0.342)
  );
  border-radius: 20px;
}
.button__change {
  top: 50%;
}
.text__center {
  left: 50%;
  right: 50%;
  margin-left: -2em;
}
</style>
